import type { PendingAttachment } from "./PendingAttachmentPreview";

// Array helpers kept in a non-component module so they can be shared with the
// composers without tripping react-refresh's only-export-components rule.
export const markAttachmentUploaded = (
  items: PendingAttachment[],
  key: string,
  id: string
): PendingAttachment[] =>
  items.map((a) => (a.key === key ? { ...a, id, status: "done" } : a));

export const dropAttachment = (items: PendingAttachment[], key: string) =>
  items.filter((a) => a.key !== key);
